import BasketMsg from 'components/BasketMsg/BasketMsg';
import withBasketMsgProps from 'viewModel/basketMsg/withBasketMsgProps';

export default withBasketMsgProps(BasketMsg);
